
import Transformer from './../transformer'


export default class MaterialsQuotationTransformer extends Transformer {
	static fetch(materialQuotationWithPagination) {

		return {
			size: materialQuotationWithPagination.size,
			totalItems: materialQuotationWithPagination.totalItems,
			page: materialQuotationWithPagination.page,
			quotations: materialQuotationWithPagination.result.map((materialQuotation, i) => {
				const supplies = materialQuotation.supply

				let highway = materialQuotation.highway
				highway = {
					id: highway.highway_id,
					name: highway.highway_name,	
				}

				let camp = materialQuotation.camp
				camp = {
					id: camp.camp_id,
					name: camp.camp_name
				}

				let receive = materialQuotation.receive
				receive = {
					id: receive.receive_id,
					name: receive.receive_name
				}

				return {
					id: materialQuotation.id,
					addDate: new Date(materialQuotation.add_date),
					camp,
					campName: camp.name,
					highway,
					highwayName: highway.name,
					folio: materialQuotation.folio,
					numSinister: materialQuotation.authorized_project.affected_name,
					receive,
					address: "Here, there, and everywhere St",
					supplies: supplies.map((supply, i) => {
						return {
							id: supply.materialsquotationsupply_id,
							supplyId: supply.supply_id,
							price: supply.price,
							supplyName: supply.materialsquotationsupply_name,
						}
					})
				}


				return {
					id: supply.materialsquotationsupply_id,
					supplyId: supply.supply_id,
					price: supply.price,
					supplyName: supply.materialsquotationsupply_name,
				}
			})
		}
	}

	static send(supplies) {
		return {
			list_supply: supplies.map(supply => {
				return {
					id: supply.id,
					price: supply.price,
					provider: supply.providerId
				}	
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/transformers/purchase/materialsQuotation.js